// Shared button style constants for the share-test-reviews feature. Kept in a neutral module (rather
// than a leaf card component) so sibling components can consume them without cross-importing each other.
export const PILL_BUTTON_CLASS = "!rounded-pill";
export const ORANGE_OUTLINE_BUTTON_CLASS = `${PILL_BUTTON_CLASS} !bg-white !border-p6-orange !text-p6-orange hover:!bg-p6-orange-light-pastel`;
